module.exports = __webpack_public_path__ + "img/edit-qty-icon.f873339f.svg";